import { render, staticRenderFns } from "./OdemeBilgileri.vue?vue&type=template&id=48411b43&"
import script from "./OdemeBilgileri.vue?vue&type=script&lang=js&"
export * from "./OdemeBilgileri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports